

function Terms({ back }) {
    
}

export default Terms;